// src/routes/ProtectedRoute.jsx
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useContext(AuthContext);

  // 🔄 AuthContext still loading → prevent flicker/white flash
  if (loading) {
    return (
      <div className="text-[#00FF99] p-8 text-center">
        Loading…
      </div>
    );
  }

  // ❌ No active session → ALWAYS force login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Authenticated → render protected content
  return children;
}
